import {
  IsNotEmpty,
  IsOptional,
  IsString,
  IsNumber,
  IsBoolean,
  ValidateIf,
  Matches,
} from "class-validator";

export class DogClubRegistrationDto {
  @IsNotEmpty()
  @IsString()
  sanctioning_club: string;

  // Registration type is optional at save time; required checks are enforced at show entry
  @IsOptional()
  @IsString()
  registration_type?: string;

  // Barn Hunt registration number validation (BH-#####)
  @ValidateIf(o => o.registration_type === 'barn_hunt')
  @Matches(/^BH-\d{5}$/, {
    message: 'Barn Hunt number must be in format BH-##### (e.g., BH-00123, BH-12345). Must have exactly 5 digits after BH- with no spaces.',
  })
  @IsOptional()
  @IsString()
  registration_number?: string;

  @IsNotEmpty()
  @IsString()
  call_name: string;

  @IsOptional()
  @IsString()
  prefix_title?: string;

  @ValidateIf(o => !['General', 'CPE', 'GCR'].includes(o.sanctioning_club) && o.registered_name !== '')
  @IsNotEmpty()
  @IsString()
  registered_name?: string;

  @IsOptional()
  @IsString()
  suffix_title?: string;

  @IsNotEmpty()
  @IsString()
  breed: string;

  @IsOptional()
  @IsString()
  variety?: string;

  @IsOptional()
  @IsString()
  variation?: string;

  @IsOptional()
  @IsBoolean()
  needs_measurement?: boolean;

  // UKC specific fields
  @IsOptional()
  @IsString()
  ukc_jump_height_type?: string;

  // AKC specific fields
  @IsOptional()
  @IsNumber()
  akc_obedience_jump_height?: number;

  @IsOptional()
  @IsNumber()
  akc_rally_jump_height?: number;

  @IsOptional()
  @IsNumber()
  akc_agility_jump_height?: number;

  @IsOptional()
  @IsNumber()
  akc_obedience_preferred_jump_height?: number;

  // CKC specific fields
  @IsOptional()
  @IsNumber()
  ckc_obedience_jump_height?: number;

  @IsOptional()
  @IsNumber()
  ckc_rally_jump_height?: number;
}
